import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as WebshopActions from './webshop.actions';
import { WebshopService } from '../../services/webshop.service';
import { Router } from '@angular/router';
import { PageComponent } from '../../pages/page/page.component';
import { routes as baseRoutes } from '../../app.routes';

@Injectable()
export class WebshopEffects {
  private actions$ = inject(Actions);
  private webshopService = inject(WebshopService);
  private router = inject(Router);

  loadWebshopData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WebshopActions.loadWebshopData),
      switchMap(() =>
        this.webshopService.getPublicData().pipe(
          map(data => WebshopActions.loadWebshopDataSuccess({data})),
          catchError(error => of(WebshopActions.loadWebshopDataFailure({error})))
        )
      )
    );
  });

  updateRoutes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WebshopActions.loadWebshopDataSuccess),
      tap(({data}) => {
        const dynamicRoutes = data.pages.flatMap(page =>
          page.slugs.map(slug => ({
            path: slug.value,
            component: PageComponent
          }))
        );

        this.router.resetConfig([
          ...baseRoutes,
          ...dynamicRoutes,
          {path: '**', redirectTo: ''}
        ]);
      })
    );
  }, {dispatch: false});
}
